import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import firebase from 'firebase/compat/app';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.scss';
import { setRealVhUnit } from './utils/setRealVhUnit';

setRealVhUnit();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

const loadingScreen = document.getElementById('loading-screen');
if(loadingScreen){
  loadingScreen.classList.add('hidden');
  setTimeout(() => loadingScreen.remove(), 500);
}

const jsWarning = document.getElementById('no-js');
if(jsWarning) {
  jsWarning.remove();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
